<template>

    <div class="tool-container">

        <!-- nav bar -->

        <nav class="navbar navbar-default navbar-fixed-top mb-3">
            <div class="navbar-inner">
                <b-row>
                    <b-col>
                        <!-- logo -->
                        <h1 class="app-title">
                            <img :src="`/img/${tool.options.logo}`" :alt="tool.label"/>
                            <span class="d-none d-sm-inline">
                        </span>
                        </h1>
                    </b-col>
                </b-row>

                <b-row>
                    <b-col>
                        <!-- title input -->
                        <b-form-input class="doc-title" type="text"
                                      v-model="doc.title"
                                      @keyup="save">
                        </b-form-input>
                        <b-btn variant="danger" size="sm" class="delete-button"
                               @click="deleteDoc()">
                            Delete Document
                        </b-btn>
                    </b-col>
                </b-row>
            </div>
        </nav>

        <b-card no-body class="tool__card">
            <b-tabs card>
                <slot name="tabs">
                    <!-- tool inserts compose/preview tabs here -->
                </slot>
            </b-tabs>
        </b-card>

    </div>

</template>

<script>

    /*
        Wrapper component containing elements common to all (?) tools:
        A top nav bar with document title field, and a slot for content tabs.

        Each tool can add as many tabs as desired, although:
        - the first tab is normally "Compose" and includes a ToolContainerComposeToolbar;
        - the second tab is normally "Preview" with a ToolContainerPreviewToolbar.
     */

    import Vue from 'vue'
    import ToolMixin from '@/providers/ToolMixin'

    export default Vue.extend({
        name: "ToolContainer",
        mixins: [ToolMixin],
        methods: {
            deleteDoc() {
                this.$api.deleteDoc(this.$store.state.docId)
                    .then(() => {
                        this.$router.go()
                    })
            }
        },
    })

</script>

<style lang="scss">

    @import 'sass/variables_mixins';

    .tool-container {

        @media print {
            .card {
                border: none;
            }
            .card-header {
                display: none;
            }
        }

        h1.app-title {
            font-size: 24px;
            margin: 8px 15px 0 15px;
            float: left;
        }

        .app-title img {
            /* width:311px; */
            height: 32px;
        }

        .navbar-inner {
            width: 100%;
        }

        input.doc-title {
            font-size: 18px;
            margin-top: 8px;
            height: 32px;
            padding: 0 5px;
            width: 300px;
        }

        .delete-button {
            margin: 8px 0 0 80px;
            padding: 5px 15px;
        }

        .step-number {
            left: 15px;
            padding: .2em .5em;
            font-size: 16px;
            color: #fff;
            border: solid 2px #fff;
            border-radius: 50%;
        }

        .card {
            > .card-body {
                //background-color: #E8E2DC;
                background-color: $light-neutral-bg;
            }
        }

        .pdf-export-wrapper {
            margin-top: 20px;
        }

        .crumbs {
            margin-bottom: 1em;
        }

    }

    .tool__card {
        border: none;
        background: transparent;

        .card-header {
            border: none;
            background: transparent;
        }

        .tab-content {
            background-color: #fff;
            @include box-shadow(0 0 20px rgba(0, 0, 0, .15));
        }

        .nav-item {
            padding-right: 10px;
            margin-bottom: 0;

            &:last-child {
                padding-right: 0;
            }
        }

        //.nav-tabs .nav-item.show .nav-link
        .nav-tabs .nav-link {
            border: none;
            background-color: #EDECEB;
            color: $text-color;
            @media(max-width: 500px) {
                padding-left: 12px;
                padding-right: 12px;
            }

            &.active {
                background-color: #fff;
                font-weight: bold;
                @include box-shadow(0 0 20px rgba(0, 0, 0, .2));
                position: relative;

                &:after {
                    position: absolute;
                    top: 100%;
                    left: -10%;
                    content: '';
                    display: block;
                    width: 120%;
                    height: 20px;
                    background-color: #fff;

                }
            }

        }

        .card-header-tabs {
            @media(min-width: 768px) {
                justify-content: center;
            }
        }

        .tab-content > .card-body {
            padding-bottom: 2em;
        }
    }

    .step-title {
        text-transform: uppercase;
        font-weight: bold;
        color: $blue;
        margin-bottom: 1em;
        font-size: 21px;
        padding-left: 26px;
        position: relative;

        &:before {
            content: '';
            display: inline-block;
            position: absolute;
            @include vertical-center;
            left: 0;
            height: 21px;
            width: 21px;
            background: url("../../public/img/header-graphic.png") no-repeat left center;

        }
    }

</style>
